import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {QueryStringService} from '@/services/QueryStringService/QueryStringService';
import {GlobalWindow, Platform, PlatformVersion} from '@/types';

export class PlatformService {
  private platform?: Platform;
  private platformVersion: PlatformVersion = null;

  constructor(
    private readonly queryStringService: QueryStringService,
    private readonly globalWindow: GlobalWindow,
  ) {}

  public init = (): void => {
    this.platformVersion = this.queryStringService.getMobileVersion();
    this.platform = this.platformVersion !== null ? 'mb' : 'web';
  };

  public getPlatform = (): Platform | undefined => {
    return this.platform;
  };

  public getPlatformVersion = (): PlatformVersion => {
    return this.platformVersion;
  };

  public isIos = (): boolean => {
    return /iPhone|iPad|iPod/i.test(this.globalWindow.navigator?.userAgent);
  };

  public isMb = (): boolean => {
    return this.platform === 'mb';
  };

  public isMbVersionMoreThanRequired = (platformVersion: PlatformVersion): boolean => {
    if (!platformVersion) {
      return false;
    }

    const currentPlatformVersion = this.getPlatformVersion()?.split('.').map(Number) || [];
    const requiredPlatformVersion = platformVersion?.split('.').map(Number) || [];

    const maxLength = Math.max(currentPlatformVersion.length, requiredPlatformVersion.length);

    for (let i = 0; i < maxLength; i++) {
      const num1 = currentPlatformVersion[i] || 0;
      const num2 = requiredPlatformVersion[i] || 0;

      if (num1 > num2) {
        return true;
      } else if (num1 < num2) {
        return false;
      }
    }

    return true;
  };
}

injected(PlatformService, DI_TOKENS.queryStringService, DI_TOKENS.globalWindow);
